function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Gender Female Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.894818,4.4408921e-14 C10.7023763,4.4408921e-14 13.789636,3.08725972 13.789636,6.894818 C13.789636,10.4930014 11.0325733,13.4479256 7.51601482,13.7620236 L7.515,16.962 L10.6523036,16.962385 C10.9235526,16.962385 11.1485792,17.1744697 11.190872,17.4523444 L11.1980144,17.5472053 C11.1980144,17.8378939 11.0001127,18.0790474 10.7408207,18.1243712 L10.6523036,18.1320255 L7.515,18.132 L7.51580771,20.7294273 C7.51580771,21.0006763 7.30372303,21.2257029 7.02584834,21.2679957 L6.93098745,21.2751381 C6.64029887,21.2751381 6.39914533,21.0772364 6.3538215,20.8179444 L6.34616719,20.7294273 L6.346,18.132 L3.1182191,18.1320255 C2.84697009,18.1320255 2.62194349,17.9199409 2.57965066,17.6420662 L2.57250822,17.5472053 C2.57250822,17.2565167 2.77040992,17.0153632 3.02970196,16.9700393 L3.1182191,16.962385 L6.346,16.962 L6.34659574,13.7681534 C2.87303413,13.4948324 0.122764277,10.6466542 0.00399846679,7.1318311 L0,6.894818 C0,3.08725972 3.08725972,4.4408921e-14 6.894818,4.4408921e-14 Z M6.894818,1.27422251 C3.79099338,1.27422251 1.27422251,3.79099338 1.27422251,6.894818 C1.27422251,9.99864262 3.79099338,12.5154135 6.894818,12.5154135 C9.99864262,12.5154135 12.5154135,9.99864262 12.5154135,6.894818 C12.5154135,3.79099338 9.99864262,1.27422251 6.894818,1.27422251 Z M9.88183594,3.3 L9.88183594,4.55146484 L5.86425781,4.55146484 L5.86425781,6.46894531 L9.40917969,6.46894531 L9.40917969,7.72041016 L5.86425781,7.72041016 L5.86425781,10.8893555 L4.5,10.8893555 L4.5,3.3 L9.88183594,3.3 Z",
  id: "gender-female-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "gender-female-Icon/Global/Female",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "gender-female-Swatches/Midnight",
  transform: "translate(5.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "gender-female-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#gender-female-path-1"
})));

var SvgGenderFemale = function SvgGenderFemale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenderFemale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gender-female.cc075f38.svg";
export { ForwardRef as ReactComponent };